/* eslint-disable react/prop-types */
import { ToastContainer } from 'react-toastify';
import { IntercomProvider } from 'react-use-intercom';
import { RecoilRoot } from 'recoil';

import MoengageWrapper from '../components/MoengageWrapper';
import I18n from '../lib/i18n';

import 'react-toastify/dist/ReactToastify.css';

export default function MyApp({ Component, pageProps }) {
  const isMoengageEnabled = process.env.NEXT_PUBLIC_ENABLE_MOENGAGE === 'true';

  return (
    <IntercomProvider appId={process.env.NEXT_PUBLIC_INTERCOM_ID}>
      <I18n lngDict={pageProps.lngDict} locale={pageProps.lng} pageId={pageProps.pageId}>
        <RecoilRoot>
          {isMoengageEnabled && <MoengageWrapper />}
          <Component {...pageProps} />
          <ToastContainer />
        </RecoilRoot>
      </I18n>
    </IntercomProvider>
  );
}
